import { Button, LoaderScreen, Typography } from 'components/common';
import Image from 'next/image';
import * as React from 'react';
import Icons from 'const/icons';
import { useNotification } from '@/hooks';
import { useRouter } from 'next/router';
import { LawyerBg } from './lawyerBg';
import { ClientBg } from './clientBg';
import { UserRol } from '@/interfaces';
import clsx from 'clsx';
import { useIsSafari } from '@/hooks/useIsSafari';

type LayoutLoginProps = {
	children: React.ReactNode;
	title?: string;
	customTitle?: React.ReactNode;
	errorMsg?: string;
	buttonBack?: boolean;
	buttonLabelBack?: string;
	hrefButtonBack?: string;
	handleBack?: () => void;
	classNameContainer?: string;
	rol?: UserRol; //pending to standadize
	loading?: boolean;
};
export const LayoutLogin: React.FC<LayoutLoginProps> = ({
	children,
	title,
	customTitle,
	errorMsg,
	buttonBack,
	buttonLabelBack,
	hrefButtonBack,
	classNameContainer,
	handleBack,
	rol = 'client',
	loading,
}) => {
	const router = useRouter();
	const { toastError } = useNotification();
	const { isSafari } = useIsSafari();

	React.useEffect(() => {
		if (errorMsg) {
			toastError(errorMsg);
		}
	}, [errorMsg]);

	return (
		<div className="w-full min-h-screen h-screen flex flex-col overflow-x-hidden bg-white">
			<div className="flex-1 overflow-y-auto">
				<div className="grid grid-cols-1 lg:grid-cols-2 w-full min-h-full">
					<div
						className={clsx(
							'flex flex-col items-center justify-start lg:justify-center pb-6',
							'pt-10 lg:pt-safe-top px-6 lg:px-[84px] bg-white w-full -webkit-overflow-scrolling-touch',
							'bg-white w-full overflow-y-auto md:overflow-y-hidden',
							{
								'pb-24 md:pb-6': isSafari,
							}
						)}
					>
						{buttonBack && !loading && (
							<div className="flex justify-start w-full mb-8">
								<Button
									icon={Icons.arrowLeft}
									iconLeft
									label={buttonLabelBack || 'Back'}
									size="fit"
									className="border-none !p-0"
									onClick={() => {
										if (handleBack) {
											handleBack();
										} else {
											if (hrefButtonBack) router.push(hrefButtonBack);
											else router.back();
										}
									}}
								/>
							</div>
						)}
						{loading ? (
							<LoaderScreen />
						) : (
							<>
								<Image
									src="/logos/logo.svg"
									alt="Logo"
									width={rol === 'client' ? 240 : 199}
									height={rol === 'client' ? 40 : 38}
									priority
									fetchPriority="high"
									decoding="sync"
								/>
								{(title || customTitle) && (
									<>
										<Typography
											type="headline-4"
											className="text-center my-8 3xl:hidden max-w-[600px]"
										>
											{title || customTitle}
										</Typography>
										<Typography
											type="headline-3"
											className="text-center my-8 hidden 3xl:block max-w-[600px]"
										>
											{title || customTitle}
										</Typography>
									</>
								)}

								<div
									className={clsx(
										'w-full lg:max-w-[556px]',
										classNameContainer
									)}
								>
									{children}
								</div>
							</>
						)}
					</div>
					<div className="bg-[#F4F4F9] hidden lg:block">
						{rol === 'client' ? <ClientBg /> : <LawyerBg />}
					</div>
				</div>
			</div>
		</div>
	);
};
